export default __webpack_public_path__ + "static/media/2425 spice rack side.24d8435e.png";